import { gql, type TypedDocumentNode } from "@apollo/client";
import type { PersonTimelineConnection, PersonTimelineObjectType } from "./types";

export interface PersonTimelineQueryResponse {
  personTimeline: PersonTimelineConnection;
}

export interface PersonTimelineQueryVariables {
  pgaId: string;
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  input?: {
    search?: string;
    objectTypes?: PersonTimelineObjectType[];
    dateRange?: {
      from?: string;
      to?: string;
    };
  };
  orderBy?: {
    field: "OCCURRED_AT" | "OBJECT_TYPE" | "TITLE" | "DESCRIPTION" | "SOURCE_LABEL" | "AUTHOR_NAME";
    direction: "ASC" | "DESC";
  };
}

export const PERSON_TIMELINE_QUERY: TypedDocumentNode<PersonTimelineQueryResponse, PersonTimelineQueryVariables> = gql`
  query PersonTimeline(
    $pgaId: ID!
    $first: Int
    $last: Int
    $after: String
    $before: String
    $input: BackofficeCRMPersonTimelineInput
    $orderBy: BackofficeCRMPersonTimelineOrderByInput
  ) {
    personTimeline(
      pgaId: $pgaId
      first: $first
      last: $last
      after: $after
      before: $before
      input: $input
      orderBy: $orderBy
    ) {
      nodes {
        id
        objectType
        title
        description
        sourceLabel
        sourcePath
        author {
          id
          name
        }
        occurredAt
        modifiedAt
        isPrivate
        isHighlight
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;
